import project from './project';


export default {
    path: 'project',
    component: () => import('@layout/empty'),
    children: [
        project,
    ]
}
